module.exports = __webpack_public_path__ + "img/faq53.4a7020d6.png";